import React from 'react';
import { ChannelCallback } from './ChannelCallback';

/** /auth/snapchat/callback — the shared sign-in callback (ChannelCallback) for Snapchat. */
const SnapchatCallback: React.FC = () => <ChannelCallback platform="snapchat" />;

export default SnapchatCallback;
